import { DATASET_PATHS } from "./DataExplorerConstants";

export const getDatasetUrlPath = (datasetId) => {
  const match = DATASET_PATHS.find(x => x.id === datasetId);
  return match ? match.path : "";
}

export const getDatasetIdFromPath = (path) => {
  const match = DATASET_PATHS.find(x => x.path === path);
  return match ? match.id : "";
}